import {
  IonIcon,
  IonImg,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
} from "@ionic/react";

import { Link, Typography } from "@mui/joy";
import {
  calendar,
  calendarOutline,
  globe,
  globeOutline,
  grid,
  gridOutline,
  logOut,
  logOutOutline,
  logoWhatsapp,
  peopleCircle,
  peopleCircleOutline,
} from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CustomToast from "../../basicsComponents/CustomToast/CustomToast";
import { Column, Row } from "../../basicsComponents/MaterialGridComponents";
import ModalPacienteForm from "../ModalFormPaciente/ModalFormPaciente";
import ModalPrivacidad from "../ModalPrivacidad.tsx";
import "./Menu.css";

const appPages = [
  {
    title: "Inicio",
    url: "/portal/Inicio",
    iosIcon: gridOutline,
    mdIcon: grid,
  },
  {
    title: "Reservar Turno",
    url: "/portal/Reservar turno",
    iosIcon: peopleCircleOutline,
    mdIcon: peopleCircle,
  },
  // {
  //   title: "Horarios Prestadores",
  //   url: "/portal/Horarios",
  //   iosIcon: peopleOutline,
  //   mdIcon: people,
  // },
  {
    title: "Mis Turnos",
    url: "/portal/Turnos",
    iosIcon: calendarOutline,
    mdIcon: calendar,
  },
  // {
  //   title: "Mis Estudios",
  //   url: "/portal/Estudios",
  //   iosIcon: fileTrayFullOutline,
  //   mdIcon: fileTrayFull,
  // },
];

const Menu = () => {
  const location = useLocation();
  const [usuario, setUsuario] = useState({});
  const [openModalPaciente, setOpenModalPaciente] = useState(false);
  const [mostrarPrivacidad, setMostrarPrivacidad] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir === true) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useEffect(() => {
    try {
      setUsuario(JSON.parse(sessionStorage.getItem("ppUL")));
    } catch {
      history.push({ pathname: "/ErrorPage" });
    }
  }, []);

  useEffect(() => {
    if (usuario.nombre !== "") {
      if (history.location.state?.justLogin === true) {
        history.location.state = {};
        setOpenModalPaciente(true);
      }
    }
  }, [usuario, history]);

  const abrirModalVerificarDatos = () => {
    setOpenModalPaciente(true);
  };

  return (
    <IonMenu contentId="main" type="overlay" className="portal-menu">
      <div className="menu-layout">
        <div className="menu-scroll-container">
          <IonImg
            src="assets/logo-grande.png"
            className="menu-logo"
            style={{ width: "240px", height: "auto" }}
          />
          <div className="menu-profile-card" onClick={abrirModalVerificarDatos}>
            <Typography level="title-lg" className="encabezado menu-profile-name">
              {usuario.apellido}, {usuario.nombre}
            </Typography>
            <div className="menu-profile-email-row">
              <Typography
                level="title-md"
                className="encabezado menu-profile-email"
              >
                {usuario.email}
              </Typography>
              <button
                type="button"
                className="menu-verify-emoji"
                aria-label="Verificar datos"
                title="Verificar datos"
                onClick={(event) => {
                  event.stopPropagation();
                  abrirModalVerificarDatos();
                }}
              >
                ✏️
              </button>
            </div>
          </div>
          <IonList id="inbox-list" className="menu-nav-list">
            {appPages.map((appPage, index) => {
              return (
                <IonMenuToggle key={index} autoHide={false}>
                  <IonItem
                    className={`menu-nav-item ${location.pathname === appPage.url ? "selected" : ""}`}
                    routerLink={appPage.url}
                    routerDirection="none"
                    lines="none"
                    detail={false}
                  >
                    <IonIcon
                      aria-hidden="true"
                      slot="start"
                      ios={appPage.iosIcon}
                      md={appPage.mdIcon}
                    />
                    <Typography
                      className="menu-item-text"
                      level={
                        location.pathname === appPage.url
                          ? "title-md"
                          : "title-sm"
                      }
                    >
                      {appPage.title.toUpperCase()}
                    </Typography>
                  </IonItem>
                </IonMenuToggle>
              );
            })}
            <IonMenuToggle autoHide={false}>
              <IonItem
                button
                lines="none"
                onClick={() => setMostrarPrivacidad(true)}
                className="menu-nav-item"
              >
                <IonIcon
                  aria-hidden="true"
                  slot="start"
                  ios={globeOutline}
                  md={globe}
                />
                <Typography level={"title-sm"} className="menu-item-text">
                  {`Política de Privacidad`.toUpperCase()}
                </Typography>
              </IonItem>
            </IonMenuToggle>
            <IonItem
              button
              lines="none"
              className="amarillo-sol menu-nav-item menu-whatsapp-item"
            >
              <IonIcon slot="start" icon={logoWhatsapp} />
              <Typography level={"title-sm"} className="menu-item-text">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://web.whatsapp.com/send?phone=+5493518150850&text=Hola!%20quiero%20hacer%20una%20consulta!"
                >
                  {`Nuestro Whatsapp`.toUpperCase()}
                </a>
              </Typography>
              <IonIcon slot="end" ios={globeOutline} md={globe} />
            </IonItem>
            <IonItem
              button
              lines="none"
              routerLink={"/"}
              className="menu-nav-item menu-logout-item"
            >
              <IonIcon
                aria-hidden="true"
                color="solid"
                slot="start"
                ios={logOutOutline}
                md={logOut}
              />
              <Typography className="menu-logout-text">
                {`Cerrar Sesion`.toUpperCase()}
              </Typography>
            </IonItem>
          </IonList>
        </div>
        <Row
          container
          justifyContent="center"
          alignItems="center"
          className="menu-powered-row menu-footer"
        >
          <Column container justifyContent="space-between" alignItems="center">
            <Link
              href="https://www.gacitua.com.ar/"
              rel="Proveedor del servicio noreferrer"
              target="_blank"
            >
              <Typography level="title-lg">
                <Typography color="neutral"> {"Powered by "}</Typography>
                <img
                  src={"assets/logoGacitua.png"}
                  alt="logo gacitua y asociados"
                  width={17}
                  height={17}
                />
                <Typography> {" Gacitua y asociados"}</Typography>
              </Typography>
            </Link>
          </Column>
        </Row>
      </div>

      <ModalPacienteForm
        openModal={openModalPaciente}
        setOpenModal={setOpenModalPaciente}
        mostrarNotificacion={mostrarNotificacion}
        paciente={usuario}
        setPaciente={setUsuario}
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={() => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />

      <ModalPrivacidad
        abrirModal={mostrarPrivacidad}
        setAbrirModal={setMostrarPrivacidad}
      />
    </IonMenu>
  );
};

export default Menu;
